import { Component, Inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { getConfiguration, getUser } from '@dcs-workspace/back-office/common';
import { withLatestFrom } from 'rxjs/operators';
import { ApmService } from '@dcs-workspace/shared';

@Component({
  selector: 'dcs-workspace-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'back-office';

  // config$ = this.configService.config$;
  // config: ConfigModel;

  // menu
  menuCode = 'data-collection-service';
  menuDataUrl = '';
  lastVisitedUrl = '';
  personName = '';
  pictureUrl = '';
  logoutUrl = 'logouturl';
  myProfileUrl = 'myprofile';
  activeMenuItem = '';
  showEventSelector = true;
  saveFavouritesUrl = '';
  eventName = '';
  imgageSrc = '';
  eventId = '';

  constructor(
    private commonStore: Store,
    @Inject(ApmService) apmService: ApmService
  ) {
    this.commonStore
      .select(getConfiguration)
      .pipe(withLatestFrom(this.commonStore.select(getUser)))
      .subscribe(([config, user]) => {
        if (user) {
          this.menuDataUrl = `${config.menuDataUrl}${this.menuCode}/${user.personId}`;
          this.personName = `${user.unique_name}`;

          if (config.apmServiceName && config.apmServerUrl) {
            const apm = apmService.init({
              serviceName: config.apmServiceName,
              serverUrl: config.apmServerUrl,
            });

            apm.setUserContext({
              username: `${user.unique_name}`,
              id: user.personId,
            });
          }
        }
      });
  }
}
